/**
 * Persistent "Test Account" indicator for test-role sessions.
 *
 * Shown only to the signed-in test user (and never on public profiles).
 * Reminds QA users that live billing, emails, referrals and public
 * statistics are sandboxed/blocked for this session.
 */
import { useAuth } from "@/contexts/AuthContext";
import { FlaskConical } from "lucide-react";

export function TestAccountBanner() {
  const { isTestAccount, isTestTrade } = useAuth();
  if (!isTestAccount) return null;

  return (
    <div
      role="status"
      aria-label="Test account session"
      className="pointer-events-none fixed bottom-20 md:bottom-4 right-4 z-[60] flex items-center gap-1.5 rounded-full border border-warning/40 bg-warning/15 px-3 py-1.5 text-[11px] font-medium text-warning shadow-sm backdrop-blur"
    >
      <FlaskConical className="h-3.5 w-3.5" />
      Test Account — {isTestTrade ? "Trade" : "Consumer"} (sandboxed)
    </div>
  );
}
